const STORAGE_KEY = "sidebar_collapsed"

const readInitialCollapsed = () => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === "1") return true
  if (stored === "0") return false
  // первый заход — на узком окне сворачиваем по умолчанию
  return typeof window !== "undefined" && window.innerWidth < 1280
}

export default {
  namespaced: true,
  state: () => ({
    sidebarCollapsed: readInitialCollapsed(),
    sidebarMobileOpen: false
  }),
  mutations: {
    setSidebarCollapsed(state, value) {
      state.sidebarCollapsed = value
      localStorage.setItem(STORAGE_KEY, value ? "1" : "0")
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
      localStorage.setItem(STORAGE_KEY, state.sidebarCollapsed ? "1" : "0")
    },
    setSidebarMobileOpen(state, value) {
      state.sidebarMobileOpen = value
    }
  }
}
